import RestAPI from './RestAPI.js';

class Filter {
    constructor() {
        if (Filter.instance) return Filter.instance;
        this.container = document.querySelector('.team-filter');

        if(this.container) {
            this.handleInitialLoad();
            this.handleInputChange();
        }

        Filter.instance = this;
    }

    handleInitialLoad() {
        const inputs = document.querySelectorAll('.team-filter input[type="radio"]');

        inputs.forEach(input => {
            if (input.checked) {
                new RestAPI().fetchData(input.value);
            }
        });
    }

    handleInputChange() {
        const radios = document.querySelectorAll('.team-filter input[type="radio"]');
        const selects = document.querySelectorAll('.team-filter select');

        const triggerChange = (value) => {
            new RestAPI().fetchData(value);

            // Fire event for the loading spinner to appear
            const filterChangeEvent = new CustomEvent('filterInputChange', {
                bubbles: true,
            });
            document.dispatchEvent(filterChangeEvent);
        };

        radios.forEach(input => {
            input.addEventListener('change', event => {
                if (event.target.checked) {
                    triggerChange(event.target.value);
                }
            });
        });

        selects.forEach(select => {
            select.addEventListener('change', event => {
                triggerChange(event.target.value);
            });
        });
    }
}

export default Filter;
